import { render } from "./view_beneficiaries.html?vue&type=template&id=452756bc&external"
import script from "./view_beneficiaries.js?vue&type=script&lang=js&external"
export * from "./view_beneficiaries.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__